export default __webpack_public_path__ + "static/media/avatars-3.26e868a1.png";